module.exports = __webpack_public_path__ + "img/json-logo.ac2cb150.svg";